import { createSelector } from '@ngrx/store';
import { selectDigitaixState } from '../core.selectors';

export const selectFeatureFlagsState = createSelector(
  selectDigitaixState,
  (state) => state.featureFlags,
);

export const isFeatureEnabled = (name: string) =>
  createSelector(
    selectFeatureFlagsState,
    (features) =>
      features.hasOwnProperty(name) ? features[name].enabled : true,
  );

export const getAllFeatureFlags = createSelector(
  selectFeatureFlagsState,
  (features) => Object.entries(features).map(([name, f]) => ({ name, ...f })),
);
